import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativeFlightsFlexibleSearchFields,
  CreativeFlightsFlexibleSearch,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getFlexibleSearchCreative = (
  fields: ConductorCreativeFlightsFlexibleSearchFields,
): CreativeFlightsFlexibleSearch => {
  let alternative;
  try {
    if (fields.alternative) {
      alternative = JSON.parse(fields.alternative);
    }
  } catch (err) {
    alternative = undefined;
  }

  const { onlyP1 } = fields;

  return {
    ...fields,
    onlyP1: (onlyP1 || '').toLowerCase() === 'true',
    alternative,
    format: ADVERT_FORMAT_TYPES.FLEXIBLE_SEARCH,
    redirectUrl: '',
  };
};
